import React, {useEffect, useState} from 'react'
import {getCurrentNews, getProjects} from "../../services";
import {NewsCard} from "../../components";

const getProject = (projects, id) => {
    return projects.find(item => item.id === id)
}

const Home = () => {
    const [currentNews, setCurrentNews] = useState([]);
    const [projects, setProjects] = useState([]);
    const [width, setWidth] = useState(window.innerWidth)
    const [leadNews, setLeadNews] = useState([])

    useEffect( () => {
        const handleResize = () => {
            setWidth(window.innerWidth)
        }

        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    useEffect(() => {
        getCurrentNews()
            .then( (response) => setCurrentNews(response.data))
    }, [])

    useEffect( () => {
        getProjects()
            .then( (response) => setProjects(response.data))
    }, [])

    useEffect( () => {
        if ( currentNews.length < 4 ) {
            setLeadNews([])
        } else if ( width >= 1400 ) {
            const tempNews = currentNews.slice(0,4)
            tempNews.sort((a,b) => b.description.length + 3*b.title.length - a.description.length - 3*a.title.length)
            console.log(tempNews);
            const longestNews = tempNews.slice(0,2)
            longestNews.sort((a,b) => a.weight - b.weight)
            const shortestNews = tempNews.slice(2,4)
            shortestNews.sort((a,b) => a.weight - b.weight)
            const finalNews = []
            finalNews.push(longestNews[0])
            finalNews.push(shortestNews[0])
            finalNews.push(shortestNews[1])
            finalNews.push(longestNews[1])
            setLeadNews(finalNews)
        } else if ( width >= 992 ) {
            const tempNews = currentNews.slice(0,3)
            tempNews.sort((a,b) => b.description.length + 3*b.title.length - a.description.length - 3*a.title.length)
            const longestNews = tempNews.slice(0,1)
            const shortestNews = tempNews.slice(1,3)
            shortestNews.sort((a,b) => a.weight - b.weight)
            const finalNews = []
            finalNews.push(shortestNews[0])
            finalNews.push(shortestNews[1])
            finalNews.push(longestNews[0])
            finalNews.push(currentNews[3])
            setLeadNews(finalNews)
        } else {
            setLeadNews(currentNews.slice(0,4))
        }
    }, [width, currentNews])

    const firstCard = leadNews.slice(0,1).map((item, index) => {
        let background = 'primary-background'
        return <NewsCard key={item.link} item={item} project={getProject(projects, item.projectId)} cardSize={2} extraClasses={background}/>
    })

    const secondCard = leadNews.slice(1,2).map((item, index) => {
        let background = 'secondary-background'
        return <NewsCard key={item.link} item={item} project={getProject(projects, item.projectId)} cardSize={1} extraClasses={background}/>
    })

    const thirdCard = leadNews.slice(2,3).map((item, index) => {
        let background = 'primary-background-alt'
        return <NewsCard key={item.link} item={item} project={getProject(projects, item.projectId)} cardSize={4} extraClasses={background}/>
    })

    const fourthCard = leadNews.slice(3,4).map((item, index) => {
        let background = 'secondary-background-alt'
        return <NewsCard key={item.link} item={item} project={getProject(projects, item.projectId)} cardSize={2} extraClasses={background}/>
    })

    const remainingCards = currentNews.slice(4,7).map((item, index) => {
        let background = 'primary-background'
        if ( index % 2 === 1 ) {
            background = 'secondary-background'
        }
        return <NewsCard key={item.link} item={item} project={getProject(projects, item.projectId)} cardSize={1} extraClasses={background}/>
    })

    return (
        <div className="home-page mt-1">
            <div className="container">
                <div className="row gx-4 gy-4 mb-2 mb-md-4">
                    {firstCard}
                    {secondCard}
                    {thirdCard}
                    {fourthCard}
                    {remainingCards}
                </div>
            </div>
        </div>
    )
}

export default Home